import { Component } from '@angular/core';

/**
 * Placeholder for the /login/callback route. The actual Okta code→token exchange is performed
 * by AppComponent (via oktaAuth.handleLoginRedirect) because the router-outlet lives inside the
 * layout, which is not rendered until the app is authorized — so a routed component here would
 * never mount during the redirect. This component just gives the route something to resolve to.
 */
@Component({
    selector: 'u4-cpp-auth-callback',
    template: ''
})
export class AuthCallbackComponent {}
